import React from "react";
import { styled } from "@mui/material/styles";
import { getStatusLabel } from "../../../../utils/digitalTwinUtils";

const getStatusColors = (status) => {
  if (status === "fine") {
    return { bg: "#EBFFEE", color: "#02542D" };
  }
  if (status === "bad") {
    return { bg: "#FEE9E7", color: "#900B09" };
  }
  if (status === "ok") {
    return { bg: "#FFFBEB", color: "#522504" };
  }
  return { bg: "#88878688", color: "#545352" };
};

const RectChip = styled("span")(({ status }) => ({
  display: "inline-flex",
  padding: "4px 16px",
  fontSize: "0.875rem",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: 500,
  borderRadius: 5,
  border: `1px solid ${getStatusColors(status).color}`,
  backgroundColor: getStatusColors(status).bg,
  color: getStatusColors(status).color,
  letterSpacing: 0.2,
  minWidth: 48,
  textAlign: "center",
  boxSizing: "border-box",
}));

const StatusChip = ({ status = "ok" }) => {
  return <RectChip status={status}>{getStatusLabel(status)}</RectChip>;
};

export default StatusChip;
